/**
 * Nurse cohort enrolment (PROD-3206) is shown only when BOTH are on: the deploy flag `VITE_COHORT_ENROLMENT` (dev only)
 * and this browser's `?x=cohorts` switch (off by default; `?x=-cohorts` turns it off again). Antonin's UI rules: anything
 * new in look or behaviour sits behind a `?x=` switch, ranked "testing" in SHOWCASE-CHANGELOG.md.
 * With either off, no cohort entry point renders and no cohort API call is made.
 */
import { env } from '@/config/env';
import { isEncounterFlagOn } from '@/shared/lib/encounter-flags';

export const isCohortEnrolmentOn = (): boolean => env.cohortEnrolmentEnabled && isEncounterFlagOn('cohorts');
